import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import CSSModules from 'helpers/CSSModulesUtil'
import T from 'i18n-react'

import { ListItem } from 'react-toolbox/lib/list'
import { IconButton } from 'react-toolbox/lib/button';
import { Flex, Box } from 'reflexbox'
import Body2 from 'components/typography/body2/index'
import Body1 from 'components/typography/body1/index'
import FileMenu from './Menu'
import { isImageFile } from 'helpers/imageUtil'
import notifyHoc from 'containers/App/Notification/Notify'

import styles from './styles.scss'

const withStyle = CSSModules(styles)

const RowItem = (
  {
    id,
    name,
    size,
  }) => {
  return (
    <Flex styleName='rowItem' align='center'>
      <div styleName='fileName'>
        <Body2>{name}</Body2>
      </div>
      <div styleName='fileSize'>
        <Body1>{size}</Body1>
      </div>
    </Flex>
  )
}

const InfoButton = notifyHoc(IconButton)

const PreviewButton = ({fileName, onPreview}) => {
  if(isImageFile(fileName)){
    return <InfoButton message="Click to preview image" icon='remove_red_eye' onClick={onPreview}/>
  }
  return <div styleName='emptyItemAction'></div>
}

const StyledRow = withStyle(RowItem)
const StyledPreviewButton = withStyle(PreviewButton)

const Item = ({ onDownload, onPreview, ...file }) => (
  <ListItem
    theme={styles}
    leftIcon='insert_drive_file'
    itemContent={
      <StyledRow {...file}/>
    }
    rightActions={[
      <StyledPreviewButton 
        fileName={file.name} 
        onPreview={onPreview}
        key={0}
      />,
      <FileMenu
        name={file.name}
        onDownload={onDownload}
        key={1}
      />
    ]}
    ripple={false}
  />
)



export default Item
